import React from 'react';
import { Card, Button, Pagination, Spinner } from 'react-bootstrap';
import { FaExclamationCircle, FaEye } from 'react-icons/fa';
import TabelaDinamica from '~/Components/TabelaDinamica/Tabela';
import { criarColunasTabelaConversaoLeads } from './UtilsConvesaoLeads';

const RenderizarPaginacao = function(props) {
  const paginaAtual = props.paginaAtual;
  const totalPaginas = props.totalPaginas;
  const mudarPagina = props.mudarPagina;

  if (totalPaginas <= 1) return null;

  const itens = [];
  const maxBotoes = 5;

  itens.push(
    <Pagination.First
      key="first"
      className="cl-pagination-boundary"
      onClick={function() {
        mudarPagina(1);
      }}
      disabled={paginaAtual === 1}
    />
  );

  itens.push(
    <Pagination.Prev
      key="prev"
      onClick={function() {
        mudarPagina(paginaAtual - 1);
      }}
      disabled={paginaAtual === 1}
    />
  );

  let inicioPaginas = Math.max(1, paginaAtual - Math.floor(maxBotoes / 2));
  let fimPaginas = Math.min(totalPaginas, inicioPaginas + maxBotoes - 1);

  if (fimPaginas - inicioPaginas < maxBotoes - 1) {
    inicioPaginas = Math.max(1, fimPaginas - maxBotoes + 1);
  }

  if (inicioPaginas > 1) {
    itens.push(
      <Pagination.Ellipsis
        key="ellipsis-start"
        className="cl-pagination-ellipsis"
        disabled
      />
    );
  }

  for (let numero = inicioPaginas; numero <= fimPaginas; numero++) {
    (function(n) {
      itens.push(
        <Pagination.Item
          key={n}
          active={n === paginaAtual}
          onClick={function() {
            mudarPagina(n);
          }}
        >
          {n}
        </Pagination.Item>
      );
    })(numero);
  }

  if (fimPaginas < totalPaginas) {
    itens.push(
      <Pagination.Ellipsis
        key="ellipsis-end"
        className="cl-pagination-ellipsis"
        disabled
      />
    );
  }

  itens.push(
    <Pagination.Next
      key="next"
      onClick={function() {
        mudarPagina(paginaAtual + 1);
      }}
      disabled={paginaAtual === totalPaginas}
    />
  );

  itens.push(
    <Pagination.Last
      key="last"
      className="cl-pagination-boundary"
      onClick={function() {
        mudarPagina(totalPaginas);
      }}
      disabled={paginaAtual === totalPaginas}
    />
  );

  return (
    <div className="cl-pagination-wrapper mt-3 mb-3">
      <Pagination className="cl-pagination mb-0">{itens}</Pagination>
    </div>
  );
};

const BotaoTags = function(props) {
  const temTags = props.temTags;
  const onClick = props.onClick;

  const estiloBtn = {
    minWidth: '32px',
    height: '32px',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <Button
      variant={temTags ? 'outline-primary' : 'outline-secondary'}
      size="sm"
      onClick={onClick}
      title={temTags ? 'Ver todas as tags' : 'Ver tags'}
      style={estiloBtn}
    >
      <FaEye size={14} />
    </Button>
  );
};

const TabelaResultados = function(props) {
  const dados = props.dados;
  const dadosPaginados = props.dadosPaginados;
  const isLoading = props.isLoading;
  const isLoadingExcel = props.isLoadingExcel;
  const buscaRealizada = props.buscaRealizada;
  const colunasVisiveis = props.colunasVisiveis;
  const paginaAtual = props.paginaAtual;
  const totalPaginas = props.totalPaginas;
  const mudarPagina = props.mudarPagina;
  const abrirModalTags = props.abrirModalTags;

  if (isLoading) {
    return (
      <Card className="mb-0">
        <Card.Body className="py-5" style={{ minHeight: 180 }}>
          <div className="text-center">
            <Spinner animation="border" role="status" variant="primary" />
            <p className="text-muted mt-3">Carregando relatório...</p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  if (isLoadingExcel && (!dados || dados.length === 0)) {
    return (
      <Card className="mb-0">
        <Card.Body className="py-5" style={{ minHeight: 180 }}>
          <div className="text-center">
            <Spinner animation="border" role="status" variant="success" />
            <h5 className="text-secondary mt-3">Gerando arquivo Excel</h5>
            <p className="text-muted mb-0">
              Aguarde enquanto o arquivo é preparado.
            </p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  if (!dados || dados.length === 0) {
    if (!buscaRealizada) {
      return null;
    }

    return (
      <Card className="mb-0">
        <Card.Body className="py-5" style={{ minHeight: 180 }}>
          <div className="text-center">
            <FaExclamationCircle size={48} className="text-secondary mb-3" />
            <h5 className="text-secondary">Nenhum registro encontrado</h5>
            <p className="text-muted">
              Não há dados para os filtros informados.
            </p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  const paginacaoProps = {
    paginaAtual: paginaAtual,
    totalPaginas: totalPaginas,
    mudarPagina: mudarPagina,
  };

  const renderizarTags = function(value, item) {
    return (
      <BotaoTags
        temTags={!!value}
        onClick={function() {
          abrirModalTags(item.codigo);
        }}
      />
    );
  };

  const colunasTabela = criarColunasTabelaConversaoLeads(renderizarTags).filter(
    function(coluna) {
      return !!colunasVisiveis[coluna.visivel];
    }
  );

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center bg-white py-2">
        <h6 className="mb-0">Relatório de Prospectos</h6>
      </Card.Header>
      <Card.Body className="p-2">
        <RenderizarPaginacao {...paginacaoProps} />
        <TabelaDinamica colunas={colunasTabela} dados={dadosPaginados} />
        <RenderizarPaginacao {...paginacaoProps} />
      </Card.Body>
    </Card>
  );
};

export default TabelaResultados;
